// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603191010/js/" + chunkId + "." + {"44":"b973c8d3","225":"740a68e2","481":"3e487aef","486":"a326c575","770":"f86c9e6c"}[chunkId] + ".0.47105194751179646.chunk.js";
};